module.exports = function (game, p16705, p16706) {
  this.boards = {};
  var v13494;
  var v13495;
  var vThis136 = this;
  this.generate = function (p16707, p16708, p16709, p16710, p16711, p16712) {
    var v13496 = p16707 + "_" + p16708 + "_" + p16710 + "_" + p16711 + "_" + p16712;
    if (!vThis136.boards[v13496]) {
      vThis136.boards[v13496] = {
        sid: p16711,
        sentTo: {}
      };
      p16706.call(155, [p16707, p16708, p16709, p16712 || 25, p16710], function (p16713, p16714) {
        p16714 = p16714 && p16714[0] ? p16714[0] : null;
        if (p16714) {
          var vA760 = [];
          for (var vLN02445 = 0; vLN02445 < p16714.length; ++vLN02445) {
            vA760.push(p16714[vLN02445].pl, p16714[vLN02445].kv);
          }
          vThis136.boards[v13496].data = vA760;
        }
      });
    }
  };
  this.sync = function () {
    for (var vLN02446 = 0; vLN02446 < game.players.list.length; ++vLN02446) {
      v13494 = game.players.list[vLN02446];
      if (v13494.active) {
        for (var v13497 in vThis136.boards) {
          if (vThis136.boards.hasOwnProperty(v13497)) {
            v13495 = vThis136.boards[v13497];
            if (!v13495.sentTo[v13494.id] && v13495.data) {
              v13495.sentTo[v13494.id] = 1;
              game.broadcast("ulb", v13495.sid, v13495.data);
            }
          }
        }
      }
    }
  };
};